defineDs('DanskeSpil/Domain/NumberGames/Scripts/Components/MultiTeaserCardsView/MultiTeaserCards', [
  'Shared/Framework/Mithril/Scripts/Core/Component',
  'Shared/Framework/Ensighten/Scripts/Ensighten',
], function (Component, Ensighten) {
  Component('multi-teaser-cards', function (m, route, settings, ignoreProperty, ignore$element) {

    const root = {
      controller: function () {
        // variables
        this.settings = m.prop(settings);

        this.itemsPerRowDesktop = this.settings().itemsPerRowDesktop || 3;
        this.itemsPerRowMobile = this.settings().itemsPerRowMobile || 1;

        this.centerItemsDesktopClass = (this.settings().cards.length > 0 && this.itemsPerRowDesktop > 1) ? 'multi-teaser-cards--center-desktop' : '';
        this.centerItemsMobileClass = (this.settings().cards.length > 0 && this.itemsPerRowMobile > 1) ? 'multi-teaser-cards--center-mobile' : '';

        this.callToActionMain = () => {
          if (this.settings().callToAction?.url) {

            if (this.settings().callToAction.url.startsWith('#')) {
              Ensighten.pushGaEvent('plus', 'multi_teaser_cards_cta_click', this.settings().callToAction.text);
            } else {
              Ensighten.pushGaEventOnPageRedirect('plus', 'multi_teaser_cards_cta_click', this.settings().callToAction.text);
            }

            window.location.href = this.settings().callToAction.url;
          }
        };

        this.callToActionCard = (card) => {
          if (card.callToAction?.url) {
            if (card.callToAction.url.startsWith('#')) {
              Ensighten.pushGaEvent('plus', 'multi_teaser_card_cta_click', card.callToAction.text);
            } else {
              Ensighten.pushGaEventOnPageRedirect('plus', 'multi_teaser_card_cta_click', card.callToAction.text);
            }
            window.location.href = card.callToAction.url;
          }
        };
      },

      view: function (controller) {
        return (
          <section className={`multi-teaser-cards multi-teaser-cards--${controller.settings().theme} multi-teaser-cards--items-per-row-desktop-${controller.itemsPerRowDesktop} multi-teaser-cards--items-per-row-mobile-${controller.itemsPerRowMobile} ${controller.centerItemsDesktopClass} ${controller.centerItemsMobileClass}`}>
            <div>
              <h2 className='multi-teaser-cards__header'>{m.trust(controller.settings().title)}</h2>
              <div className='multi-teaser-cards__content'>{m.trust(controller.settings().text)}</div>
              <div className='multi-teaser-cards__cards'>
                {controller.settings().cards.map(function (card) {
                  let imageSource = card.image?.src || card.image?.source;
                  return (
                    <div className='multi-teaser-cards__card'>
                      {imageSource ? <div style={`background-image:url('${imageSource}')`} className='multi-teaser-cards__card__image'></div> : ''}
                      <h3 className='multi-teaser-cards__card__title' >{m.trust(card.title)}</h3>
                      <div className='multi-teaser-cards__card__text'>{m.trust(card.text)}</div>
                      {card.callToAction?.url ? <div className='multi-teaser-card__cta-container'><div className='multi-teaser-cards__cta'><a onclick={controller.callToActionCard(card)}>{card.callToAction.text}</a></div></div> : ''}
                    </div >
                  );
                })}
              </div>
              {controller.settings().callToAction?.url ? <div className='multi-teaser-cards__cta'><a onclick={controller.callToActionMain} className='multi-teaser-cards__cta_button'>{controller.settings().callToAction.text}</a></div> : ''}
            </div>
          </section>
        );
      }
    };
    route('/', root);
  });
});
